export {
  dateToISO,
  dateToISODate,
  dateToCompact,
}

function dateToISO(value) {
  return value ? `${value.substr(0,4)}-${value.substr(4,2)}-${value.substr(6,2)} ${value.substr(8)}` : ''
}

function dateToISODate(value) {
  return value ? `${value.substr(0,4)}-${value.substr(4,2)}-${value.substr(6,2)}` : ''
}

function dateToCompact(value) {
  let res = value ? value.replace(/[-\s]/g, '') : '';
  if (res.length === 13) {
    res += ':00';
  }
  return res;
}
